(function () {
  var root = document.getElementById('notb-namegen');
  if (!root) return;
  var L = root.getAttribute('data-lang') === 'en' ? 'en' : 'nl';
  var T = {
    nl: { copy: 'Kopieer', copied: 'Gekopieerd', save: 'Bewaar', saved: 'Bewaard', spotify: 'Check Spotify', saveTitle: 'Bewaarde namen', share: 'Deel', none: 'Tik op ☆ om namen te bewaren.' },
    en: { copy: 'Copy', copied: 'Copied', save: 'Save', saved: 'Saved', spotify: 'Check Spotify', saveTitle: 'Saved names', share: 'Share', none: 'Tap ☆ to save names.' }
  }[L];

  var W = {
    general: ['Ghost', 'Nova', 'Echo', 'Blaze', 'Raven', 'Vandal', 'Cobra', 'Viper', 'Orbit', 'Comet', 'Nomad', 'Rebel', 'Storm', 'Prism', 'Onyx', 'Cipher', 'Titan', 'Atlas', 'Zenith', 'Mirage', 'Static', 'Neon', 'Chrome', 'Frost', 'Ember', 'Ronin', 'Oracle', 'Riot', 'Havoc', 'Ace', 'Kaiser', 'Baron', 'Bandit', 'Outlaw', 'Pilot', 'Rocket', 'Diesel', 'Turbo', 'Karma', 'Mystic', 'Falcon', 'Wolf', 'Fox', 'Shark', 'Voltage', 'Glitch', 'Pixel', 'Saga', 'Rumble', 'Vibe', 'Mosaic', 'Quartz', 'Granite', 'Copper', 'Indigo', 'Zephyr', 'Jet', 'Flux', 'Delta', 'Sonic', 'Maverick'],
    dark: ['Ghost', 'Phantom', 'Havoc', 'Riot', 'Smoke', 'Shadow', 'Viper', 'Cobra', 'Raven', 'Venom', 'Vandal', 'Grim', 'Onyx', 'Static', 'Frost', 'Reaper', 'Menace', 'Chaos', 'Hex', 'Wraith', 'Fang', 'Ruin', 'Ash', 'Steel', 'Spike'],
    smooth: ['Velvet', 'Lotus', 'Jade', 'Nova', 'Halo', 'Mirage', 'Silk', 'Honey', 'Luna', 'Ivory', 'Pearl', 'Opal', 'Sienna', 'Amber', 'Cloud', 'Dream', 'Rosé', 'Satin', 'Coral', 'Aura', 'Bloom', 'Mellow', 'Dusk', 'Solace', 'Haze'],
    adj: ['Cold', 'Lost', 'Golden', 'Silent', 'Wild', 'Lucky', 'Royal', 'Lazy', 'Shady', 'Swift', 'Heavy', 'Fly', 'Smooth', 'Real', 'Blue', 'Silver', 'Late', 'Midnight', 'Neon', 'Lowkey', 'Restless', 'Electric', 'Quiet', 'Rare'],
    nl1: ['Zuid', 'Noord', 'Oost', 'West', 'Polder', 'Nacht', 'Maan', 'Storm', 'Donder', 'Bliksem', 'Vuur', 'IJs', 'Goud', 'Zilver', 'Staal', 'Beton', 'Asfalt', 'Mist', 'Regen', 'Haven', 'Dijk', 'Kroon', 'Schaduw'],
    nl2: ['vos', 'wolf', 'haai', 'kraai', 'slang', 'leeuw', 'spook', 'prins', 'vorst', 'jager', 'ruiter', 'dief', 'stem', 'vogel', 'tijger', 'adelaar', 'beer', 'valk', 'boef', 'lord'],
    pre: ['Lil', 'Young', 'Big', 'Kid', 'Baby', 'Don', 'Sir', 'King', 'Yung'],
    area: ['010', '020', '030', '040', '050', '070', '073', '076'],
    prod: ['Beats', 'Wav', '808', 'Keys', 'Made', 'Tracks', 'Audio', 'Sound', 'Bounce', 'Loops']
  };

  var BLOCK = ['lil wayne', 'lil kim', 'lil baby', 'lil uzi', 'lil nas', 'lil peep', 'lil durk', 'lil yachty', 'lil pump', 'lil tecca', 'lil tjay', 'lil mosey', 'lil skies', 'lil xan', 'lil dicky', 'lil jon', 'lil kleine', 'lil ghost', 'young thug', 'young ellens', 'young dolph', 'young money', 'young buck', 'young jeezy', 'young fox', 'yung lean', 'big sean', 'big boi', 'big shaq', 'big l', 'big pun', 'kid cudi', 'kid ink', 'kid laroi', 'baby keem', 'baby tate', 'red velvet', 'black panther', 'black mamba', 'silver surfer', 'smokepurpp', 'ghostface', 'nova twins', 'cold play', 'coldplay', 'royal blood', 'blue ivy', 'golden child', 'wild child', 'king von', 'kingpin', 'sir lord', 'don toliver', 'midnight star', 'electric light', 'lost frequencies', 'havoc', 'echo', 'nova', 'raven', 'halo', 'saint', 'ace hood', 'smooth criminal', 'boef', 'zuid', 'king ghost'];

  function r(a) { return a[Math.floor(Math.random() * a.length)]; }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function clean(s) { return (s || '').replace(/[^\p{L}\p{N} .'-]/gu, '').replace(/\s+/g, ' ').trim().slice(0, 24); }

  function fromName(n, style) {
    var first = n.split(' ')[0];
    var base = cap(first.toLowerCase());
    var ini = n.split(' ').filter(Boolean).map(function (p) { return p[0].toUpperCase(); }).join('');
    var stem = base.replace(/[aeiouy]+$/i, '') || base;
    var f = [
      function () { return r(W.pre) + ' ' + base; },
      function () { return base + ' ' + r(style === 'drill' ? W.dark : style === 'rnb' ? W.smooth : W.general); },
      function () { return stem + r(['o', 'ito', 'z', 'x', 'zo']); },
      function () { return r(W.adj) + ' ' + base; },
      function () { return base + ' ' + r(W.area); },
      function () { return ini.length > 1 ? ini.split('').join('.') + '.' : base + r(['z', 'x']); },
      function () { return base.split('').reverse().join('').toLowerCase().replace(/^./, function (c) { return c.toUpperCase(); }); }
    ];
    if (style === 'prod') f = [
      function () { return base + r(W.prod); },
      function () { return base + ' ' + r(W.prod); },
      function () { return 'Prod. ' + base; },
      function () { return base + 'OnThe' + r(['Keys', 'Track', 'Wav', 'Loop']); },
      function () { return stem + r(['o', 'x', 'z']) + ' ' + r(['Beats', 'Wav']); }
    ];
    return r(f)();
  }

  function fresh(style) {
    var pool = style === 'drill' ? W.dark : style === 'rnb' ? W.smooth : W.general;
    var f;
    if (style === 'prod') f = [
      function () { return r(W.general) + r(W.prod); },
      function () { return r(W.adj) + ' ' + r(W.general) + ' ' + r(['Beats', 'Wav']); },
      function () { return r(W.nl1) + r(W.nl2) + ' ' + r(W.prod); },
      function () { return 'Prod. ' + r(W.general); }
    ];
    else if (style === 'drill') f = [
      function () { return r(pool) + ' ' + r(W.area); },
      function () { return r(['Kid', 'Young', 'Don', 'Lil']) + ' ' + r(pool); },
      function () { return r(W.adj) + ' ' + r(pool); },
      function () { return r(W.nl1) + r(W.nl2); },
      function () { return r(pool).toUpperCase().replace(/I/g, '1').replace(/O/g, '0'); }
    ];
    else if (style === 'rnb') f = [
      function () { return r(pool); },
      function () { return r(W.adj) + ' ' + r(pool); },
      function () { return r(pool) + ' ' + r(pool); },
      function () { return r(pool).toLowerCase(); },
      function () { return r(['Baby', 'Sir', 'Lady']) + ' ' + r(pool); }
    ];
    else f = [
      function () { return r(W.pre) + ' ' + r(pool); },
      function () { return r(W.adj) + ' ' + r(pool); },
      function () { return r(W.nl1) + r(W.nl2); },
      function () { return r(pool) + ' ' + r(W.area); },
      function () { return r(pool) + r(['o', 'z', 'x']); }
    ];
    return r(f)();
  }

  function ok(n, seen) {
    var k = n.toLowerCase();
    if (seen[k]) return false;
    for (var i = 0; i < BLOCK.length; i++) { if (k === BLOCK[i] || k.indexOf(BLOCK[i] + ' ') === 0 && BLOCK[i].indexOf(' ') > 0) return false; }
    return n.length >= 3 && n.length <= 26;
  }

  var input = root.querySelector('[data-ng-input]');
  var grid = root.querySelector('[data-ng-grid]');
  var savedBox = root.querySelector('[data-ng-saved]');
  var savedList = root.querySelector('[data-ng-saved-list]');
  var style = 'rap';
  var saved = [];

  root.querySelectorAll('[data-ng-style]').forEach(function (b) {
    b.addEventListener('click', function () {
      style = b.getAttribute('data-ng-style');
      root.querySelectorAll('[data-ng-style]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      gen();
    });
  });

  function icon(p) { return '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="' + p + '" fill="currentColor"/></svg>'; }
  var I_COPY = icon('M8 7V3h12v14h-4v4H4V7h4zm2 0h6v8h2V5h-8v2zM6 9v10h8V9H6z');
  var I_SPOT = icon('M12 2a10 10 0 100 20 10 10 0 000-20zm4.6 14.4a.8.8 0 01-1.1.3c-3-1.8-6.7-2.2-11.1-1.2a.8.8 0 11-.4-1.6c4.8-1.1 8.9-.6 12.3 1.4.4.2.5.7.3 1.1zm1.2-2.7a1 1 0 01-1.4.3c-3.4-2.1-8.6-2.7-12.6-1.5a1 1 0 11-.6-1.9c4.6-1.4 10.3-.7 14.3 1.7.5.3.6.9.3 1.4zm.1-2.8C14 8.6 7.5 8.4 3.8 9.5a1.2 1.2 0 11-.7-2.3c4.3-1.3 11.4-1 15.9 1.6a1.2 1.2 0 01-1.1 2.1z');

  function card(n) {
    var li = document.createElement('li');
    li.className = 'ng-card';
    var isSaved = saved.indexOf(n) > -1;
    li.innerHTML = '<span class="ng-name"></span><span class="ng-actions">' +
      '<button type="button" class="ng-ic" data-a="save" aria-pressed="' + isSaved + '" aria-label="' + T.save + '" title="' + T.save + '">' + (isSaved ? '★' : '☆') + '</button>' +
      '<button type="button" class="ng-ic" data-a="copy" aria-label="' + T.copy + '" title="' + T.copy + '">' + I_COPY + '</button>' +
      '<a class="ng-ic" data-a="spot" target="_blank" rel="noopener" aria-label="' + T.spotify + '" title="' + T.spotify + '">' + I_SPOT + '</a></span>';
    li.querySelector('.ng-name').textContent = n;
    li.querySelector('[data-a=spot]').href = 'https://open.spotify.com/search/' + encodeURIComponent(n) + '/artists';
    li.querySelector('[data-a=copy]').addEventListener('click', function (e) {
      var btn = e.currentTarget;
      (navigator.clipboard ? navigator.clipboard.writeText(n) : Promise.reject()).then(function () {
        btn.classList.add('is-done'); btn.title = T.copied; setTimeout(function () { btn.classList.remove('is-done'); btn.title = T.copy; }, 1200);
      }).catch(function () {});
    });
    li.querySelector('[data-a=save]').addEventListener('click', function (e) {
      var i = saved.indexOf(n);
      if (i > -1) saved.splice(i, 1); else saved.push(n);
      e.currentTarget.textContent = i > -1 ? '☆' : '★';
      e.currentTarget.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
      renderSaved();
    });
    return li;
  }

  function renderSaved() {
    savedBox.hidden = saved.length === 0;
    savedList.textContent = saved.join(' · ');
  }

  function gen() {
    var n = clean(input.value);
    var seen = {}, out = [], tries = 0;
    while (out.length < 8 && tries < 400) {
      tries++;
      var cand = (n && Math.random() < 0.6) ? fromName(n, style) : fresh(style);
      cand = cand.replace(/\s+/g, ' ').trim();
      if (ok(cand, seen)) { seen[cand.toLowerCase()] = 1; out.push(cand); }
    }
    grid.innerHTML = '';
    out.forEach(function (x, i) { var c = card(x); c.style.animationDelay = (i * 35) + 'ms'; grid.appendChild(c); });
  }

  root.querySelector('[data-ng-go]').addEventListener('click', gen);
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); gen(); } });
  var share = root.querySelector('[data-ng-share]');
  share.addEventListener('click', function () {
    var txt = saved.join(', ');
    var data = { title: document.title, text: txt, url: location.href };
    if (navigator.share) navigator.share(data).catch(function () {});
    else if (navigator.clipboard) navigator.clipboard.writeText(txt + ' ' + location.href);
  });
  gen();
})();
